<template>
  <ProfessionalLoginTemplate>
    <h4>Reset your password</h4>
    <p class="text-muted">
      Enter your email address to request password reset instructions.
    </p>
    <div class="form">
      <div v-if="errors.length > 0" class="margin-bottom-twenty danger-well">
        <ion-text v-for="error in errors" color="danger" :key="error">
          {{ error }}
        </ion-text>
      </div>
      <form @submit.prevent="checkForm" class="login-form">
        <input class="form-control" type="email" v-model="email" placeholder="Email address" />
        <button class="prime-button button-block margin-top-ten" :class="{ 'button-pending': isLoading }">
          <span>Send link</span>
          <ion-spinner name="dots" duration="1200" />
        </button>
        <p class="message">
          Already registered?
          <router-link to="/">Login</router-link>
        </p>
      </form>
    </div>
  </ProfessionalLoginTemplate>
</template>

<script>
import { send as httpSend } from "@/services/Api";
import ProfessionalLoginTemplate from "@/components/Login/Templates/TemplateLoginProfessional";

export default {
  name: "FormLoginPasswordForgot",
  components: {
    ProfessionalLoginTemplate
  },
  data() {
    return {
      email: "",
      isLoading: false,
      errors: []
    };
  },
  methods: {
    submit: async function() {
      this.isLoading = true;
      const payload = this.email;
      const method = "post";
      const path = document.config.forgotPassword;
      const headers = {
        "Content-Type": "text/plain"
      };

      try {
        const response = await httpSend({ path, method, payload, headers });
        
        // Check if this is an SSO user
        if (response.data && response.data.status === 'sso_user') {
          this.isLoading = false;
          
          // Show popup notification for SSO users
          this.$ionic.alertController.create({
            header: 'Single Sign-On Account',
            message: response.data.message,
            buttons: ['OK']
          }).then(alert => alert.present());
          
          return; // Don't redirect, stay on the page
        }
        
        // Continue with existing success flow for password users
        this.$router.push({
          name: "success",
          params: {
            title: "Email Sent",
            body: "If an account exists for this address, an email will be sent with further instructions to reset your password.",
            navlink: '<a href="/">Back to Login</a>'
          }
        });
        
      } catch (error) {
        this.isLoading = false;
        this.errors.push("An error occurred. Please try again.");
      }
    },
    checkForm: function(e) {
      this.errors = [];

      if (!this.email) {
        this.errors.push("Please enter a valid email address.");
      }
      if (!this.errors.length) {
        this.submit();
      }
      e.preventDefault();
    }
  }
};
</script>

<style scoped>
.form {
  position: relative;
  z-index: 1;
  max-width: 290px;
  margin: 20px auto;
  text-align: center;
}
.form .message {
  margin: 15px 0 0;
  color: var(--ion-color-medium);
  font-size: 12px;
  font-weight: 500;
}
.form .message a {
  color: var(--ion-color-primary);
  text-decoration: none;
}
.form .message a:hover {
  color: var(--ion-color-primary-shade);
}
</style>
